(($) => {
	$(document).ready(() => {

		$('#menu-toggle').click(function() {	
			$('#small-menu').slideToggle(function(){
			});
		});

	});
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/navigation.js